import React, { useEffect } from "react";
import { useFormik } from "formik";
import { yupSchemaStep8 } from "schemas/yupSchema";
import UploadFile from "components/UploadFile";
import CustomSelect from "components/CustomSelect";
import MultipleUploadFile from "components/MultipleUploadFile";
import NavigateButtons from "components/NavigateButtons";
import CustomInput from "components/CustomInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TextInfo from "components/TextInfo";
import { goToTop, refToErrorFormik, addBusinessDays } from "helpers/helpers";
import objectsSchema from "schemas/objectsSchema";
import ro from "date-fns/locale/ro";
import { requestJson, RequestMethod } from "helpers/httpHelper";
import { prepareDataStep8 } from "helpers/PrepareData";
import { toast } from "react-toastify";

export default function Step8({ currentStep, setCurrentStep, stepsState, persistState, setLoading, firstSubmit, setFirstSubmit }) {
   // let firstDayNextMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1, 5).toISOString().split("T")[0];
   // let fiveDaysFromToday = new Date(new Date().getTime() + 5 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
   // Obținem data de azi
   const today = new Date();

   // Adăugăm cinci zile lucrătoare
   let fiveDaysFromToday = addBusinessDays(today, 5).toISOString().split("T")[0];

   const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
         calitateDetinator: stepsState.step8.calitateDetinator,
         valabilitateChirie: stepsState.step8.valabilitateChirie,
         fileCoProprietar: stepsState.step8.fileCoProprietar,
         scopConsum: stepsState.step8.scopConsum,
         unitateMasura: stepsState.step8.unitateMasura,
         categorieConsum: stepsState.step8.categorieConsum,
         indexLuni: stepsState.step8.indexLuni,
         sumOfIndexLuni: stepsState.step8.sumOfIndexLuni,
         acordConventieConsum: stepsState.step8.acordConventieConsum,
         indexContorPhoto: stepsState.step8.indexContorPhoto,
         indexContorManual: stepsState.step8.indexContorManual,
         dataLivrare: fiveDaysFromToday,
         pod: stepsState.step8.pod,
         consum: stepsState.step6.consum,
         isPIF: stepsState.step4.isPIF,
      },
      validationSchema: yupSchemaStep8,
      validateOnChange: firstSubmit,
      validateOnBlur: false,
      onSubmit: values => {
         goToTop();
         saveData(values);
      },
   });

   const addDaysToCalendar = (date, days) => {
      const copy = new Date(Number(date));
      copy.setDate(date.getDate() + days);
      return copy;
   };

   const labelCalitateDetinator = objectsSchema.calitatiDetinator.find(item => item.value === formik.values.calitateDetinator)?.label;

   const saveData = async values => {
      setLoading(true);
      // console.log("values8", stepsState);
      var opportunityId = stepsState.opportunityId;
      if (opportunityId === undefined || opportunityId === null) {
         console.log('opportunityId is undefined or null');
         toast.error("Va rugam sa incercati din nou.");
      }
      const allData = { ...values, ...stepsState.step4, ...stepsState.step6,  opportunityId: stepsState.opportunityId };
      const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS8, RequestMethod.POST, { data: await prepareDataStep8(allData) });
      if (response.isSuccess) {
         persistState(prevState => {
            return {
               ...prevState,
               step8: {
                  ...prevState.step8,
                  calitateDetinator: values.calitateDetinator,
                  valabilitateChirie: values.valabilitateChirie,
                  fileCoProprietar: values.fileCoProprietar,
                  scopConsum: values.scopConsum,
                  unitateMasura: values.unitateMasura,
                  categorieConsum: values.categorieConsum,
                  indexLuni: values.indexLuni,
                  indexContorPhoto: values.indexContorPhoto,
                  indexContorManual: values.indexContorManual,
                  dataLivrare: values.dataLivrare,
                  pod: values.pod,
                  acordConventieConsum: values.acordConventieConsum,
               },
            };
         });
         window.dataLayer.push({ event: "pas_8_casnici", info: { pagina: "step-8", finalizat: "da" } })
         localStorage.setItem("sessionCurrentStep", currentStep + 1);
         setCurrentStep(currentStep + 1);
         setFirstSubmit(false);
      } else {
         toast.error("Nu s-au putut salva datele. Va rugam sa incercati din nou.");
      }
      setLoading(false);
   };

   const formSubmition = e => {
      document.getElementById('stepActions').setAttribute( 'style', 'display:none !important;' );
      document.getElementById('stepActions').style.setProperty('display', 'none', 'important');
      document.getElementById('stepActions').style.display = "none";
      e.preventDefault();
      setFirstSubmit(false);
      formik.handleSubmit();
      setTimeout(() => {
         document.getElementById('stepActions').setAttribute( 'style', 'display:block !important;' );
         document.getElementById('stepActions').style.setProperty('display', 'block', 'important');
         document.getElementById('stepActions').style.display = "block";
      }, "5000");
   };

   const handleChangeCategorieConsum = value => {
      formik.setFieldValue("categorieConsum", value.value);
      if (value.value === "C1") formik.setFieldValue("indexLuni", objectsSchema.indexLuniSchemaC1);
      if (value.value === "C2") formik.setFieldValue("indexLuni", objectsSchema.indexLuniSchemaC2);
      if (value.value === "C3") formik.setFieldValue("indexLuni", objectsSchema.indexLuniSchemaC3);
   };

   useEffect(() => {
      // console.log('errors', formik.errors)
      refToErrorFormik(formik);
   }, [formik]);

   const first6Months = objectsSchema.row1.map((item, index) => {
      return (
         <div className="col-lg-2 col-6 mb-768" key={index}>
            <label className="capitalize" htmlFor={item}>
               {item}
            </label>
            <CustomInput
               id={`indexLuni.${item}`}
               name={`indexLuni.${item}`}
               type={"text"}
               value={formik.values.indexLuni?.[item]}
               error={formik.errors.indexLuni?.[item]}
               touched={formik.touched.indexLuni?.[item]}
               setFieldValue={formik.setFieldValue}
               preventLetters={true}
               isDebounced={false}
            />
         </div>
      );
   });
   const last6Months = objectsSchema.row2.map((item, index) => {
      return (
         <div className="col-lg-2 col-6 mb-768" key={index}>
            <label className="capitalize" htmlFor={item}>
               {item}
            </label>
            <CustomInput
               id={`indexLuni.${item}`}
               name={`indexLuni.${item}`}
               type={"text"}
               value={formik.values.indexLuni?.[item]}
               error={formik.errors.indexLuni?.[item]}
               touched={formik.touched.indexLuni?.[item]}
               setFieldValue={formik.setFieldValue}
               preventLetters={true}
               isDebounced={false}
            />
         </div>
      );
   });

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  <div className="pas-8">
                     <h2 className="first_title">Completează datele de mai jos pentru a-ți putea genera declarația pe proprie răspundere.</h2>
                     <form onSubmit={e => formSubmition(e)}>
                        <div className="row row-input mt-50">
                           <div className="col-md-12">
                              <CustomSelect
                                  options={objectsSchema.calitatiDetinator}
                                  name={"calitateDetinator"}
                                  id={"calitateDetinator"}
                                  labelDescription={"În ce calitate deții imobilul situat la adresa locului de consum?"}
                                  value={formik.values.calitateDetinator}
                                  onChange={value => formik.setFieldValue("calitateDetinator", value.value)}
                                  placeholder="Selectează..."
                                  isError={formik.errors.calitateDetinator && formik.touched.calitateDetinator}
                              />
                              {formik.errors.calitateDetinator && formik.touched.calitateDetinator && (
                                  <span className="error-msg">{formik.errors.calitateDetinator}</span>
                              )}
                           </div>
                        </div>
                        {(formik.values.calitateDetinator === "chirias" || formik.values.calitateDetinator === "comodator") && (
                            <div className="row row-input mt-50">
                               <div className=" col-md-12">
                                  <label htmlFor="valabilitateChirie">
                                     {/* {formik.values.calitateDetinator === "chirias" ? "Valabilitate chirie" : "Până la ce dată"} */}
                                     Până la ce dată
                                  </label>
                                  {/*<CustomInput*/}
                                  {/*   id={"valabilitateChirie"}*/}
                                  {/*   name={"valabilitateChirie"}*/}
                                  {/*   type={"date"}*/}
                                  {/*   value={formik.values.valabilitateChirie}*/}
                                  {/*   onChange={formik.handleChange}*/}
                                  {/*   error={formik.errors.valabilitateChirie}*/}
                                  {/*   touched={formik.touched.valabilitateChirie}*/}
                                  {/*   preventLetters={true}*/}
                                  {/*   maxLengthText={10}*/}
                                  {/*   placeholder={`Adaugați data expirării contractului`}*/}
                                  {/*/>*/}
                                  <DatePicker
                                      name="valabilitateChirie"
                                      id={"valabilitateChirie"}
                                      selected={formik.values.valabilitateChirie ? new Date(formik.values.valabilitateChirie) : ""}
                                      onChange={date => formik.setFieldValue("valabilitateChirie", date)}
                                      dateFormat="dd/MM/yyyy"
                                      minDate={addDaysToCalendar(new Date(), 0)}
                                      locale={ro}
                                  />
                                  {formik.errors.valabilitateChirie && formik.touched.valabilitateChirie && (
                                      <span className="error-msg">{formik.errors.valabilitateChirie}</span>
                                  )}
                               </div>
                               <div className="color-gray2 font-size-12">
                                  Scrie data expirării contractului de chirie în formatul zi/lună/an. Exemplu:
                                  01/05/2021
                               </div>
                            </div>
                        )}
                        <p className="contr-sub text-center mt-30">{`DOCUMENTE ${labelCalitateDetinator?.toUpperCase() ?? ""}`}</p>
                        <div className="row text-center mt-30 ">
                           <div className="col-md-12 position-relative ml-auto mr-auto">
                              <MultipleUploadFile
                                  setFieldValue={formik.setFieldValue}
                                  name={"fileCoProprietar"}
                                  error={formik.errors.fileCoProprietar}
                                  touched={formik.touched.fileCoProprietar}
                                  calitateaDetinatorului={formik.values.calitateDetinator}
                                  id={"fileCoProprietar"}
                              />
                           </div>
                        </div>
                        <label htmlFor="scopConsum">
                           <p className="contr-sub2 mt-30">Scop consum</p>
                           <div className="col-md-12 mt-20">
                              <div className="check-div">
                                 <input
                                     id="scopConsum"
                                     defaultChecked={formik.values.scopConsum}
                                     value={formik.values.scopConsum}
                                     // onChange={formik.handleChange}
                                     type="checkbox"
                                     readOnly={true}
                                 />
                                 <span className="checkmark-static"></span>Declar că folosesc gazele exclusiv pentru
                                 desfășurarea activităților
                                 casnice
                              </div>
                           </div>
                        </label>
                        <TextInfo
                            containerClassNames={"col-md-12 d-flex mt-30 mb-3 items-center"}
                            textClassNames={"contr-sub2 mb-0"}
                            text={"Convenție cu program de consum"}
                            hoverText={
                               "În lipsa unui index citit de către distribuitor (operatorul de sistem) sau în lipsa unui index transmis de tine (autocitire), consumul de gaze naturale va fi estimat în baza istoricului de consum înregistrat la fiecare loc de consum sau în lipsa unui istoric de consum, estimarea se va face după graficul de consum trimis de tine."
                            }
                        />
                        <div className="row row-input mt-50">
                           <div className="col-md-12">
                              <div className="row align-items-center">
                                 <div className="col-md-6 mb-768">
                                    <label htmlFor="unitateMasura">Unitate de măsurare</label>
                                    <input
                                        id="unitateMasura"
                                        name="unitateMasura"
                                        type="text"
                                        value={formik.values.unitateMasura}
                                        readOnly
                                        className="input-text"
                                    />
                                 </div>
                                 <div className="col-md-6">
                                    <CustomSelect
                                        options={objectsSchema.categoriiConsum}
                                        name={"categorieConsum"}
                                        id={"categorieConsum"}
                                        value={formik.values.categorieConsum}
                                        onChange={value => handleChangeCategorieConsum(value)}
                                        placeholder="Selectează..."
                                        isError={formik.errors.categorieConsum && formik.touched.categorieConsum}
                                        labelDescription={"Categorie de consum"}
                                    />
                                    {formik.errors.categorieConsum && formik.touched.categorieConsum && (
                                        <span className="error-msg">{formik.errors.categorieConsum}</span>
                                    )}
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="row mt-4">{first6Months}</div>
                        <div className="row mt-2">{last6Months}</div>
                        {formik.errors.sumOfIndexLuni && formik.touched.sumOfIndexLuni && (
                            <div className="error-msg mt-3">{formik.errors.sumOfIndexLuni}</div>
                        )}

                        <div className="col-md-12 mt-4">
                           <label htmlFor="acordConventieConsum" className="check2 mb-0">
                              Am înțeles și sunt de acord cu convenția de consum introdusă.
                              <input
                                  defaultChecked={formik.values.acordConventieConsum}
                                  value={formik.values.acordConventieConsum}
                                  onChange={formik.handleChange}
                                  id="acordConventieConsum"
                                  type="checkbox"
                              />
                              <span
                                  className={`checkmark2 ${
                                      formik.errors.acordConventieConsum && formik.touched.acordConventieConsum ? "error-msg-checkbox" : ""
                                  }`}
                              ></span>
                           </label>
                           {formik.errors.acordConventieConsum && formik.touched.acordConventieConsum && (
                               <div className="error-msg">{formik.errors.acordConventieConsum}</div>
                           )}
                        </div>
                        {stepsState.step4.isPIF === false ? (
                            <>
                               <label className="mt-30">
                                  <TextInfo
                                      containerClassNames={"col-md-12 d-flex items-center"}
                                      textClassNames={"mb-0"}
                                      text={"Indexul autocitit din momentul în care este realizată solicitarea"}
                                      isOptional={true}
                                      hoverText={
                                         "Indexul afișat de contor până la separatorul de numere întregi (până la cifrele roșii sau semnul virgulă “,”)."
                                      }
                                  />
                               </label>

                               <div className="row row-input mt-30">
                                  <div className="col-md-12">
                                     <label htmlFor="indexContorManual"></label>
                                     <CustomInput
                                         id={"indexContorManual"}
                                         name={"indexContorManual"}
                                         type={"text"}
                                         value={formik.values.indexContorManual}
                                         error={formik.errors.indexContorManual}
                                         touched={formik.touched.indexContorManual}
                                         setFieldValue={formik.setFieldValue}
                                         onlyNumbers={true}
                                     />
                                  </div>
                               </div>
                               <div className="row text-center mt-30 justify-content-center">
                                  <UploadFile
                                      // changeText={true}
                                      setFieldValue={formik.setFieldValue}
                                      name={"indexContorPhoto"}
                                      id={"indexContorPhoto"}
                                      value={formik.values.indexContorPhoto}
                                  />
                                  {formik.errors.indexContorPhoto && formik.touched.indexContorPhoto && (
                                      <div className="text-center error-msg">{formik.errors.indexContorPhoto}</div>
                                  )}
                               </div>
                            </>) : (
                            null
                        )}
                        <p className="contr-sub2 mt-30">Data începerii furnizării cu gaze naturale</p>
                        <div className="row row-input mt-20">
                           {stepsState.step4.isPIF === false ? (
                               <div className="col-md-12">
                                  <DatePicker
                                      name="dataLivrare"
                                      selected={new Date(formik.values.dataLivrare)}
                                      onChange={date => formik.setFieldValue("dataLivrare", date.toISOString().split("T")[0])}
                                      dateFormat="dd MMM yyyy"
                                      minDate={addDaysToCalendar(new Date(), 4)}
                                      maxDate={addDaysToCalendar(new Date(), 30)}
                                      locale={ro}
                                  />
                                  {formik.errors.dataLivrare && formik.touched.dataLivrare && (
                                      <div className="error-msg">{formik.errors.dataLivrare}</div>
                                  )}
                               </div>
                           ) : (
                               <div className="col-md-12">
                                  <DatePicker
                                      name="dataLivrare"
                                      selected={new Date(formik.values.dataLivrare)}
                                      onChange={date => formik.setFieldValue("dataLivrare", date.toISOString().split("T")[0])}
                                      dateFormat="dd MMM yyyy"
                                      minDate={addBusinessDays(new Date(), 5)}
                                      maxDate={addDaysToCalendar(new Date(), 30)}
                                      locale={ro}
                                  />
                                  {formik.errors.dataLivrare && formik.touched.dataLivrare && (
                                      <div className="error-msg">{formik.errors.dataLivrare}</div>
                                  )}
                               </div>
                           )}
                        </div>
                        <p className="contr-sub2 mt-30 mb-2">
                           Codul Locului de consum (CLC) <span className="optional">(obligatoriu)</span>
                        </p>
                        <div className="row row-input mt-20">
                           <div className="col-md-12">
                              <div className="color-gray2 font-size-12 mt-0 mb-2">
                                 CLC-ul (codul locului de consum) este numărul unic de identificare al locului tău de
                                 consum, adică locul unde se iți
                                 vom face furnizarea de gaze naturale și îl poți vedea pe factură și în contractul tău
                                 de furnizare a gazelor
                                 naturale.
                              </div>
                              <CustomInput
                                  id={"pod"}
                                  name={"pod"}
                                  type={"text"}
                                  onlyUpperCase={true}
                                  value={formik.values.pod}
                                  error={formik.errors.pod}
                                  touched={formik.touched.pod}
                                  setFieldValue={formik.setFieldValue}
                                  preventSpecialCharacters={true}
                              />
                           </div>
                        </div>
                           <div id="stepActions">
                              <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep}/>
                           </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}
